import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useGetEndorsementsQuery } from "../../../../store/Company/companyApiSlice";
import { selectActiveCompanyId } from "../../../../store/activeCompanySlice";
import { profileStatus, VERIFIED, CLAIMED } from "./profileStatus";

/* The endorsement banner's inputs.
 *
 * TRANSCRIBED from BannerCompanyCard:492-511 and its render gate at 1715.
 *
 * TIP-492/504 — viewing endorsements is member-gated on the VIEWER's active
 * company, so the endpoint answers one of three ways and the mode is derived
 * from which:
 *
 *   endorsements: []        a member viewer — the real count, mode "member"
 *                           (and nothing at all when the list is empty)
 *   teaser + has_endorsements
 *                           a non-member viewer of a company that has some —
 *                           mode "prompt", no count
 *   public === false        not a member company / nothing to show — no mode
 */
export const endorsementDisplay = (endorsementView) => {
  if (!endorsementView || endorsementView.public === false) {
    return { mode: null, count: 0 };
  }
  if (Array.isArray(endorsementView.endorsements)) {
    const count = endorsementView.endorsements.length;
    return { mode: count > 0 ? "member" : null, count };
  }
  if (endorsementView.teaser && endorsementView.has_endorsements) {
    return { mode: "prompt", count: 0 };
  }
  return { mode: null, count: 0 };
};

/* Transcribed gate: a verified company only to a viewer with NO role on it, and a claimed company to anyone. */
export const showsEndorsementBanner = (companyType, role) =>
  (companyType === VERIFIED && !role) || companyType === CLAIMED;

export const useEndorsements = ({ company, role }) => {
  const { id } = useParams();
  const { token, userInfo } = useSelector((state) => state.auth);
  const activeCompanyId = useSelector(selectActiveCompanyId);

  const { data: endorsementView } = useGetEndorsementsQuery(
    { companyId: id, actingCompanyId: activeCompanyId, token },
    { skip: !id || !token }
  );

  /* The live `companyType` chain is the legacy one, which is exactly what
     profileStatus already computes. */
  const companyType = profileStatus(company);
  const { mode, count } = endorsementDisplay(endorsementView);

  return {
    companyType,
    endorsementMode: mode,
    endorsementCount: count,
    userInfo,
    visible: showsEndorsementBanner(companyType, role),
  };
};

export default useEndorsements;
